var generic = generic || {};
var site = site || {};

(function ($) {
  Drupal.behaviors.emailSignupBlockCoresiteV1 = {
    templateContainer: $('.js-email-signup-block-coresite-v1'),
    initEmailSignupBlock: function (context) {
      var self = this;
      var $emailContainer = self.templateContainer.find('.js-personal-info-form-container', context);

      if (!$emailContainer) {
        return null;
      }

      var urlParams = new URLSearchParams(window.location.search);
      var emailParam = urlParams.get('email');
      if (emailParam) {
        $emailContainer.find('#edit-form-email-address').val(emailParam);
      }

      var $emailFormNode = $emailContainer.find('form');
      var $dateDropdown = $emailContainer.find('.js-edit-form-age');

      if ($dateDropdown.length !== 0) {
        var $selectDay = $('.js-edit-form-age-day');
        var $selectMonth = $('.js-edit-form-age-month');
        var $selectYear = $('.js-edit-form-age-year');
        var currentYear = new Date().getFullYear();
        var i = 1;

        for (i = 1; i <= 31; i++) {
          $selectDay.append($('<option></option>').val(i).html(i));
        }

        for (i = 1; i <= 12; i++) {
          $selectMonth.append($('<option></option>').val(i).html(i));
        }

        for (i = currentYear - 18; i >= currentYear - 100; i--) {
          $selectYear.append($('<option></option>').val(i).html(i));
        }
      }

      $emailFormNode.once('email_signup').on('submit', function (submitEvt) {
        submitEvt.preventDefault();

        $emailContainer.find('.form-error div').addClass('hidden');
        $emailContainer.find('.form-item').removeClass('label-error');

        var fields = [
          '_SUBMIT',
          'ACTION',
          'FIRST_NAME',
          'LAST_NAME',
          'EMAIL_ADDRESS',
          'EMAIL_ADDRESS2',
          'ADDRESS1',
          'ADDRESS2',
          'COUNTRY',
          'CITY',
          'POSTAL_CODE',
          'PHONE1',
          'EMAIL_PROMOTIONS',
          'ACCEPTED_PRIVACY_POLICY',
          'LANGUAGE_PREFERENCE',
          'LAST_SOURCE'
        ];

        if ($dateDropdown.length !== 0) {
          fields.push('AGE');
          fields.push('REQUIRED_AGE');
          fields.push('BIRTH_DAY');
          fields.push('BIRTH_MONTH');
          fields.push('BIRTH_YEAR');
          var $birthDay = $('.js-edit-form-age-day').val();
          var $birthMonth = $('.js-edit-form-age-month').val();
          var $birthYear = $('.js-edit-form-age-year').val();
          var birthDate = new Date();
          var currentDate = new Date();

          birthDate.setFullYear($birthYear, $birthMonth - 1, $birthDay);

          var age = currentDate.getFullYear() - birthDate.getFullYear();
          var m = currentDate.getMonth() - birthDate.getMonth();

          if (m < 0 || (m === 0 && currentDate.getDate() < birthDate.getDate())) {
            age--;
          }

          if ($birthDay !== '' || $birthMonth !== '' || $birthYear !== '') {
            $('.js-edit-form-age').val(age);
          }
        }

        var paramObj = {};

        // loop through all the fields and get the values
        $.each(fields, function (index, value) {
          var $formField = $emailContainer.find('input[name=' + value + ']');

          if (value === 'BIRTH_DAY' || value === 'BIRTH_MONTH' || value === 'BIRTH_YEAR') {
            $formField = $emailContainer.find('select[name=' + value + ']');
          }

          // for the unchecked checkboxes we want to send empty strings to backend for processing
          if ($formField.is(':checkbox') && !$formField.prop('checked')) {
            paramObj[value] = '';
          } else {
            paramObj[value] = $formField.val();
          }
        });
        if ($.cookie('csrftoken')) {
          paramObj['_TOKEN'] = $.cookie('csrftoken');
        }

        // Send the data via a json rpc call
        generic.jsonrpc.fetch({
          method: 'rpc.form',
          params: [paramObj],
          onSuccess: function () {
            window.location.href = $emailContainer.find('input[name=THANK_YOU_PAGE]').val();
          },
          onFailure: function (jsonRpcResponse) {
            var messages = jsonRpcResponse.getMessages();
            var key, field, fieldClass;

            $.each(messages, function (i, message) {
              key = message.key.replaceAll('.', '-');
              key = '.js-' + key;
              field = message.tags[2];
              fieldClass = field.replace('field', '');

              $emailContainer.find(key).removeClass('hidden');
              $emailContainer.find('.form-item' + fieldClass).addClass('label-error');
            });
          }
        });
      });
    },
    attach: function (context) {
      var self = this;

      self.initEmailSignupBlock(context);
    }
  };
})(jQuery);
